import React from 'react';
import { Shield } from 'lucide-react';
import { WA_URL } from './Shared';
export function TopBar() {
  return <div className="sticky top-0 z-40 w-full bg-slate-900 text-white border-b border-slate-800 shadow-sm" data-id="element-196">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-14 flex items-center justify-between text-sm" data-id="element-197">
        <div className="flex items-center gap-2 font-medium" data-id="element-198">
          <Shield className="w-5 h-5 text-slate-300 hidden sm:block" data-id="element-199" />
          <span className="hidden md:inline" data-id="element-200">
            Solución a Pensión | Asesoría Pensional Independiente | Sin
            conflicto de interés
          </span>
          <span className="md:hidden font-semibold" data-id="element-201">Solución a Pensión</span>
        </div>
        <a href={WA_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-[#25D366] hover:text-[#1EBE5D] font-semibold transition-colors" data-id="element-202">
          <span className="hidden sm:inline" data-id="element-203">📲 Contáctanos por WhatsApp</span>
          <span className="sm:hidden" data-id="element-204">📲 WhatsApp</span>
        </a>
      </div>
    </div>;
}